//Created by wangshuyi on 07/03/2018.

'use strict';
let commonPageScript = {
  data() {
    this.query = this.$Dolphin.debounce(this.query, 500);
    return {
      tableName: '',
      primaryKey: '',

      selectedRowKeys: [],
      selectedRows: [],
      ignoreSubmitFields: [],

      queryForm: {},
      detailVisible: false,
      detailForm: {},

      editVisible: false,
      editForm: {},

      asEdit: false,
      saving: false,

      validateRules: {},

      //用于实现查询条件的显示/隐藏
      pageName: '',
      showQueryFormField: [],
      queryFormFieldArea: []
    };
  },
  methods: {
    query() {
      if (this.$refs.list) {
        this.$refs.list.query();
      }
      if (this.$refs.tree) {
        this.$refs.tree.query();
      }
      if (this.$refs.parentSelect) {
        this.$refs.parentSelect.getOption();
      }
    },
    load() {
      if (this.$refs.list) {
        this.$refs.list.load();
      }
    },
    beforeAdd(data) {},
    clearObj(){
      Object.keys(this.queryForm).forEach(key=>{
        this.queryForm[key]=''
      })
      this.afterClearObj(this.queryForm)
    },
    afterClearObj(data){},
    add() {
      let data = {};
      this.beforeAdd(data);
      this.editForm = data;

      this.asEdit = false;
      this.clearValidate();
      this.editVisible = true;
    },
    beforeEdit(data) {},
    edit(data) {
      let updateData = { ...data };
      this.beforeEdit(updateData);
      this.asEdit = true;
      this.clearValidate();
      this.editForm = updateData;
      this.editVisible = true;
    },
    beforeSave(data) {
      return Promise.resolve(data);
    },
    validate(success, failed) {
      if (this.$refs.editForm) {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            if (typeof success === 'function') {
              success();
            }
          } else {
            if (typeof failed === 'function') {
              failed();
            }
            return false;
          }
        });
      } else {
        success();
      }
    },
    save() {
      if (!this.tableName) {
        this.$message.error('未配置tableName。');
        return false;
      }
      if (!this.primaryKey) {
        this.$message.error('未配置primaryKey。');
        return false;
      }
      this.validate(() => {
        this.beforeSave(this.editForm).then(data => {
          delete data.RN;
          delete data.CREATE_BY;
          delete data.CREATE_DATE;
          delete data.UPDATE_BY;
          delete data.UPDATE_DATE;
          this.ignoreSubmitFields.forEach(f => delete data[f]);

          this.saving = true;
          this.$h5Api({
            type: '1002',
            data: [this.$dotNetUtil.commonSaveJson(this.tableName, this.primaryKey, this.asEdit, [data])],
          }).then(reData => {
            this.editVisible = false;
            this.$message.info(reData.message);
            this.afterSave();
            this.query();
          }).catch(e => {
          }).finally(() => {
            this.saving = false;
          });
        });
      });
    },
    afterSave() {},
    removeOne(record) {
      let message = this.$t('deleteMessages');
      this.$confirm({
        content: message,
        okText:this.$t('confirm'),
        cancelText:this.$t('cancel'),
        onOk: () => {
          let data = [{
            [this.primaryKey]: record[this.primaryKey],
          }];
          return this.$h5Api({
            type: '1004',
            data: [this.$dotNetUtil.commonDeleteJson(this.tableName, this.primaryKey, data)],
          }).then(reData => {
            this.$message.info(reData.message);
            this.query();
          });
        },
        onCancel() {
        },
      });
    },
    clearValidate() {
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
    },
    pickConditionField(value) {
      if(value){
        localStorage.setItem(this.pageName + 'ConditionField', value);
      }else{
        localStorage.setItem(this.pageName + 'ConditionField', '');
      }

      let removeCondition = this.queryFormFieldArea.concat().filter(field => !value.includes(field.code));
      let newCondition = this.queryForm;
      removeCondition.forEach(field => {
        if (field.fields) {
          field.fields.forEach(field => delete newCondition[field]);
        } else if (field.computedField) {
          this[field.computedField] = field.defaultValue;
        } else {
          delete newCondition[field.code];
        }
      });
      this.queryForm = newCondition;
      // 主动触发查询，在这触发是否会过于频繁
      // this.query();
    }
  },
  created() {
    let incomeConditionField = localStorage.getItem(this.pageName + 'ConditionField');
    this.showQueryFormField = incomeConditionField ? incomeConditionField.split(',') : [];
  }
};

export default commonPageScript;
